import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { CmsService } from 'src/app/core/services/cms.service';
import { CmsObject } from 'src/app/model/cmsobject';

@Component({
    selector: 'ms-import-export-management-card',
    templateUrl: './import-export-management-card.component.html',
    styleUrls: ['./import-export-management-card.component.scss'],
})
export class ImportExportManagementCardComponent implements OnInit {
    public mng_impexp_title: string;
    public mng_impexp_descri: string;
    language: string;
    public cmsObj: CmsObject[];

    constructor(private router: Router, private workFlow: WorkFlowService, public cmsService: CmsService) {}

    async ngOnInit() {
        await this.getCmsObj();
    }
    async getCmsObj() {
        this.language = this.workFlow.getLanguageForCms();
        //recupero le stringhe della pagina
        this.cmsObj = await this.cmsService.getCmsObj(this.language, 'accountcomponent');
        this.mng_impexp_title = this.cmsObj.find((x) => x.ContentName == 'accountcomponent.mng_impexp_title').ContentTranslation;
        this.mng_impexp_descri = this.cmsObj.find((x) => x.ContentName == 'accountcomponent.mng_impexp_descri').ContentTranslation;
    }

    public navigate() {
        this.router.navigate(['/import-export-home']);
    }
}
